<div>
    <!-- <h2>Our Partners</h2> -->
    <div #partnerList class="partner-list">
      <div *ngFor="let partner of partners" class="partner-item">
        <img src="{{ partner.icon }}" alt="Partner Icon">
      </div>
    </div>
  </div>